// extracted by mini-css-extract-plugin
module.exports = {"validiFiWidget":"IavButton-module__validiFiWidget___2WNTq"};